import { cloudProviderSchema } from './cloud-provider.schema';
import { roleSchema } from './role.schema';
import { termsAcceptedSchema } from './terms-accepted.schema';
import { coercedDate } from '../utils/coerced-date';
import { z } from 'zod/v4';

export const authenticatedUserSchema = z.object({
  userId: z.number().min(1),
  username: z.string().min(1),
  authToken: z.string().min(1),
  authTokenCreatedOn: coercedDate.optional(),
  authTokenTTL: z.number().optional(),
  accountName: z.string().nullable(),
  accountId: z.number().min(1),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  roles: z.array(roleSchema),
  currentTermsAccepted: termsAcceptedSchema,
  forcePasswordReset: z.boolean().nullish(),
  accessToken: z.string().nullable(),
  idToken: z.string().nullable(),
  cloudProvider: cloudProviderSchema,
});

export type AuthenticatedUser = z.infer<typeof authenticatedUserSchema>;
